(function () {
	var modalEl = document.getElementById('mediaDetailsModal');
	var titleEl = modalEl.querySelector('.modal-title');
	var videoWrapperEl = document.getElementById('modalVideoWrapper');
	var videoEl = document.getElementById('modalVideo');
	var descEl = document.getElementById('modalDescription');

	modalEl.addEventListener('show.bs.modal', function (event) {
		var trigger = event.relatedTarget;
		if (!trigger) return;

		var title = trigger.getAttribute('data-title') || '';
		var youtube = (trigger.getAttribute('data-youtube') || '').trim();
		var contentId = trigger.getAttribute('data-content-id');

		// Titolo
		titleEl.textContent = title;

		// Video
		if (youtube) {
			var src = 'https://www.youtube.com/embed/' + encodeURIComponent(youtube) + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
			videoEl.setAttribute('src', src);
			videoWrapperEl.classList.remove('d-none');
		} else {
			videoEl.setAttribute('src', '');
			videoWrapperEl.classList.add('d-none');
		}

		// Descrizione
		if (contentId) {
			var sourceEl = document.getElementById(contentId);
			if (sourceEl) {
				descEl.innerHTML = sourceEl.innerHTML;
			}
		}
	});

	modalEl.addEventListener('hidden.bs.modal', function () {
		videoEl.setAttribute('src', '');
		videoWrapperEl.classList.add('d-none');
		descEl.textContent = '';
		titleEl.textContent = '';
	});
})();